import { Box, IconButton, Popover } from "@mui/material";
import { useState } from "react";
import { SketchPicker } from "react-color";
import ColorizeIcon from "@mui/icons-material/Colorize";

const ColorPicker = ({ color, onChange, name }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleChange = (color) => {
    onChange(name, color);
  };

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleEyedrop = async () => {
    if (!window.EyeDropper) {
      alert("Eyedropper API is not supported in this browser.");
      return;
    }

    try {
      const eyeDropper = new window.EyeDropper();
      const result = await eyeDropper.open();
      handleChange({ hex: result.sRGBHex });
    } catch (err) {
      console.error("Eyedropper cancelled or failed:", err);
    }
  };

  return (
    <Box sx={{ position: "relative" }}>
      <IconButton onClick={handleOpen}>
        <Box
          height={25}
          width={25}
          sx={{
            backgroundColor: color,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        />
      </IconButton>
      <IconButton onClick={handleEyedrop}>
        <ColorizeIcon />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <SketchPicker color={color} onChange={handleChange} />
      </Popover>
    </Box>
  );
};

export default ColorPicker;
